import { FormattedMessage } from "react-intl";

import Nbsp from "@components/Nbsp";
import BodyCopy from "@components/typography/BodyCopy";
import ExternalLink from "@components/typography/ExternalLink";
import InternalLink from "@components/typography/InternalLink";
import useMyExpert from "@hooks/useMyExpert";
import { GetJourneyForMessagesQuery } from "@typing/Generated";
import { isIosNativeApp } from "@utils/platformUtils";
import { journeyRoute } from "@utils/routeUtils";

type Props = {
  journey: GetJourneyForMessagesQuery["journey"];
};

const MessageFormDisabled = ({ journey }: Props) => {
  const myExpert = useMyExpert();

  return (
    <div className="flex flex-column gap-lg ion-margin-horizontal align-center margin-20-top">
      <div>
        <BodyCopy color="gray">
          <FormattedMessage id="pages.messages.hoursUsed" />
        </BodyCopy>
        <Nbsp />
        {!isIosNativeApp() && (
          <>
            <InternalLink
              linkEventCreateVariables={{ journeyId: journey.id }}
              to={journeyRoute({
                journeyId: journey.id,
                linkAfterJourney: "/account?section=package",
                myExpert,
                preventScroll: false
              })}
            >
              <FormattedMessage id="pages.messages.purchaseHours" />
            </InternalLink>
            <FormattedMessage id="dictionary.punctuation.period" />
          </>
        )}
      </div>

      <div>
        <FormattedMessage id="pages.messages.haveAQuestion" />
        <Nbsp />
        <ExternalLink href="mailto:support@withgrayce.com" linkEventCreateVariables={{ journeyId: journey.id }}>
          <FormattedMessage id="pages.messages.contactSupport" />
        </ExternalLink>
        <FormattedMessage id="dictionary.punctuation.period" />
      </div>
    </div>
  );
};

export default MessageFormDisabled;
